export default __webpack_public_path__ + "static/small-icons-dark-0a7cf26295aaaaf2f777c635535920d32a945f3db9f8962a229a03c32c302027.png";